import './style.scss';
import $ from 'jquery';
import './javascripts/_validateInput';
import 'bxslider/dist/jquery.bxslider';

$(function () {
  $('.p-shops-gallary').each(function (i) {
    i++;
    console.log('bxslider_' + i);
    $('.bxslider_' + i).bxSlider({
      pager: true,
      controls: false,
      pagerCustom: '.bxslider_thumbnail_' + i
    });
  });
});

$(function () {
  function initMap($el) {
    var $markers = $el.find('.marker');

    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map($el[0], mapArgs);

    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    centerMap(map);
    return map;
  }

  function initMarker($marker, map) {
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    var marker = new google.maps.Marker({
      icon: {
        url: '../../wp-content/themes/hikari/images/pin.png',
        scaledSize: new google.maps.Size(30, 38)
      },
      position: latLng,
      map: map
    });
    map.markers.push(marker);
    if ($marker.html()) {
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
    } else {
      map.fitBounds(bounds);
    }
  }

  $(document).ready(function () {
    $('.acf-map').each(function () {
      var map = initMap($(this));
    });
  });
});

const burger = document.querySelector('.c-burger');

burger.addEventListener('click', function () {
  console.log('fheihfie');
  document.querySelector('.l-header-menu').classList.toggle('nav-open');
  document.querySelector('.c-burger__wrapper').classList.toggle('c-burger--active');
  document.body.classList.toggle('no-scroll');
});

$(window).on('load', function () {
  var $delayTime = 500;
  var $loadingAnim = $('.c-loading'),
    $body = $('body');
  $body.addClass('is-loaded');
  setTimeout(function () {
    $loadingAnim.find('.c-loading_content').on('transitionend', function (e) {
      $(this).parent().remove();
    });
  }, $delayTime);
});

$(function () {
  if (
    (navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) ||
    navigator.userAgent.indexOf('iPod') > 0 ||
    navigator.userAgent.indexOf('Android') > 0
  ) {
    $('.js-header-button').attr('href', 'tel:0465240612');
  } else {
    $('.js-header-button').attr('href', '/contact');
  }
});

$(function () {
  function getParam() {
    var url = window.location.href;

    if (url.match(/\/contact\/#/)) {
      console.log('url');
      var reg = new RegExp('\\#(.+?)$');
      if (url.match(reg)) {
        var str = url.match(reg)[1];
        console.log();
        $('#' + str).prop('checked', true);
      }
    }
  }
  getParam();
});
